<template>
	<tr>		
		<td><b-link href="#"  @click.prevent="onUpdateClick">{{ contact.Name }}</b-link></td>
       
        <td>{{ formatDate(contact.Added) }}</td>
        <td>{{ formatDate(contact.Updated) }}</td>
		
	</tr>
</template>
<script>
// import shared functions
import { dateFuncs } from "@/globs.js";

export default {
	name: "ContactListRow",

	props: ["contact"],

	methods: {
		
		onUpdateClick() {
			this.$emit("update", this.contact.Id);
		},
		
        formatDate(date) {
			return dateFuncs.backEndDateFormat(date);
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/contact/contact-list-row.vue